var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgNotConnected = function SvgNotConnected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: "currentColor"
  })));
};
export default SvgNotConnected;